(function () {
  function getHeaderBottom() {
    var selectors = [
      'sticky-header',
      '.shopify-section-header-sticky',
      '.section-header',
      '.header-wrapper',
      'header'
    ];

    var bottom = 0;

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.height > 0 && rect.bottom > bottom && rect.top <= rect.bottom) {
          bottom = rect.bottom;
        }
      });
    });

    return Math.max(0, bottom);
  }

  function syncMobilePosition(mobileBar) {
    if (!mobileBar) return;

    var top = getHeaderBottom();
    document.documentElement.style.setProperty('--article-recommendations-mobile-top', top + 'px');
    document.documentElement.style.setProperty('--article-recommendations-mobile-height', mobileBar.offsetHeight + 'px');
    document.body.classList.add('article-recommendations-mobile-active');
  }

  function syncDesktopPosition() {
    var top = getHeaderBottom() + 16;
    document.documentElement.style.setProperty('--article-recommendations-desktop-top', top + 'px');
  }

  function moveDesktopRecommendation(root) {
    var desktop = root.querySelector('[data-article-recommendations-desktop]');
    var sidebar = document.querySelector('.custom-sidebar');

    if (!desktop || !sidebar) return;

    var toc = sidebar.querySelector('.article-template-nav.hidden_mb');
    var social = sidebar.querySelector('.sidebar-social');
    var stack = sidebar.querySelector('[data-article-recommendations-sticky-stack]');

    if (!stack) {
      stack = document.createElement('div');
      stack.className = 'article-recommendations-sticky-stack';
      stack.setAttribute('data-article-recommendations-sticky-stack', '');

      if (toc && toc.parentNode === sidebar) {
        toc.insertAdjacentElement('afterend', stack);
      } else {
        sidebar.insertAdjacentElement('afterbegin', stack);
      }
    }

    stack.appendChild(desktop);

    if (social) {
      stack.appendChild(social);
    }
  }

  function replaceShortcodes(root) {
    var article = document.querySelector('.article-template-content.rte');
    var templates = root.querySelector('[data-article-recommendations-templates]');

    if (!article || !templates) return;

    var html = article.innerHTML;
    if (html.indexOf('[[product-recommend:') === -1) return;

    article.innerHTML = html.replace(/\[\[product-recommend\s*:\s*([a-zA-Z0-9_-]+)\s*\]\]/g, function (match, key) {
      var template =
        templates.querySelector('[data-article-recommendation-template="' + key + '"]') ||
        templates.querySelector('[data-product-handle="' + key + '"]');

      return template ? template.innerHTML : match;
    });
  }

  function bindDesktopCarousel(root) {
    var carousel =
      root.querySelector('[data-article-recommendations-carousel]') ||
      document.querySelector('[data-article-recommendations-carousel]');
    if (!carousel) return;

    var viewport = carousel.querySelector('[data-article-recommendations-viewport]');
    var track = viewport ? viewport.querySelector('.article-recommendations-list--carousel') : null;
    var controls = carousel.querySelector('[data-article-recommendations-controls]');
    var prev = carousel.querySelector('[data-article-recommendations-prev]');
    var next = carousel.querySelector('[data-article-recommendations-next]');
    var cards = track ? Array.from(track.querySelectorAll('.article-recommendation-card')) : [];
    var currentIndex = 0;

    if (!viewport || !track || !prev || !next) return;

    function updateButtons() {
      var hasOverflow = cards.length > 1;
      if (controls) {
        controls.hidden = !hasOverflow;
      }
      prev.disabled = !hasOverflow || currentIndex === 0;
      next.disabled = !hasOverflow || currentIndex >= cards.length - 1;
    }

    function goToCard(index) {
      currentIndex = Math.max(0, Math.min(index, cards.length - 1));
      track.scrollTo({
        left: cards[currentIndex].offsetLeft,
        behavior: 'smooth'
      });
      updateButtons();
    }

    prev.addEventListener('click', function () {
      goToCard(currentIndex - 1);
    });

    next.addEventListener('click', function () {
      goToCard(currentIndex + 1);
    });

    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  function bindMobileToggle(root) {
    var mobileBar = root.querySelector('[data-article-recommendations-mobile]');
    var toggle = root.querySelector('[data-article-recommendations-toggle]');
    var panel = root.querySelector('[data-article-recommendations-panel]');

    if (!mobileBar || !toggle || !panel) return;

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      panel.hidden = expanded;
      window.requestAnimationFrame(function () {
        syncMobilePosition(mobileBar);
      });
    });

    syncMobilePosition(mobileBar);

    window.addEventListener('resize', function () {
      syncMobilePosition(mobileBar);
    });

    window.addEventListener('scroll', function () {
      syncMobilePosition(mobileBar);
    }, { passive: true });
  }

  function initArticleRecommendations() {
    document.querySelectorAll('[data-article-recommendations]').forEach(function (root) {
      if (root.dataset.hideLegacySidebar === 'true') {
        document.body.classList.add('article-recommendations-hide-legacy-sidebar');
      }

      replaceShortcodes(root);
      bindDesktopCarousel(root);
      moveDesktopRecommendation(root);
      bindMobileToggle(root);
      syncDesktopPosition();
    });

    window.addEventListener('resize', syncDesktopPosition);
    window.addEventListener('scroll', syncDesktopPosition, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticleRecommendations);
  } else {
    initArticleRecommendations();
  }
})();
